export default "__VITE_ASSET__H0s2dH3i__"